module.exports = __webpack_public_path__ + "img/red_blue.20994bb4.jpg";